/* eslint-disable */
import { useState,useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import axios from "axios";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Resizer from "react-image-file-resizer";

import { Button, Modal, CardContent } from '@mui/material';
import { LoadingButton } from "@mui/lab";

import { useEnumApi } from 'contexts/EnumApiContext';
import { ROLE } from 'data/data';
import { getEquipmentsById } from "components/axios/equipmentAxios";
import MainCard from 'components/MainCard';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import FileDownloadIcon from "components/FileDownloadIcon";
import Chip from '@mui/material/Chip';
import { customFileAxios } from "components/axios/customAxios";

const EquipmentImgFileModifyLayer = ({equipmentId, setIsLoading}) => {

    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const { role } = useEnumApi();
    const [info, setInfo] = useState(null);
    // const [imgFile, setImgFile] = useState(null);
    // const [imgFileId, setImgFileId] = useState(null);
    const [inputImageItems, setInputImageItems] = useState([]);
    const nextImgID = useRef(1);
    const [fileLoading, setFileLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const { register, handleSubmit, formState : {isDirty, errors } } = useForm({});
    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');
    
    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };

    const handleOpen = () => {
        setOpen(true);
    }
    const handleClose = () => setOpen(false);

    useEffect(() => {
        if (equipmentId && !loading) {
            getEquipmentsById(equipmentId).then((data)=>{
                if (data) {
                    setInfo(data);
                    // setImgFileId((data.imgFile && data.imgFile.id) || null);
                    if (data.imgFiles && data.imgFiles.length > 0) {
                        let inputImageItemsCopy = [];
                        nextImgID.current = 1;
                        for (var j=0;j<data.imgFiles.length;j++) {
                            const input = {	
                                id: nextImgID.current,
                                file: {},
                                imgFile: data.imgFiles[j],
                            };
                            inputImageItemsCopy = [...inputImageItemsCopy, input]
                            nextImgID.current += 1;
                        }
                        setInputImageItems(inputImageItemsCopy);
                    }
                } else {
                    setInfo(null);
                    // setImgFileId(null);
                }
                setLoading(true);
            })
        }
    },[equipmentId, loading]);

    // function fileChangedHandler(event, maxWith, maxHeight, responseUriFunc) {
    //     if (event.target?.files?.[0]) {
    //       try {
    //         Resizer.imageFileResizer(event.target.files[0], maxWith, maxHeight, "JPEG", 90, 0, responseUriFunc, "file", 0, 0)
    //       } catch (err) {
    //         // console.log(err);
    //         alertMessage = err.message;
    //         setAlertMessage(alertMessage);
    //         handleAlertClick();
    //         responseUriFunc('')
    //       }
    //     }
    // }

    // 기본이미지삭제
    // function deleteImgFile() {
    //     setImgFileId(null);
    //     setImgFile(null);
    // }

    function addImageFile(file) {
        const input = {	
            id: nextImgID.current,
            file: {},
            imgFile: file,
        };

        setInputImageItems([...inputImageItems, input]);
        nextImgID.current += 1;
    }

    // 삭제
    function deleteImageFile(index) {
        setInputImageItems(inputImageItems.filter(item => item.id !== index));
    }

    async function handleImageFileChange(e, index) {
        if (index > inputImageItems.length) return;

        const compressedFile = (await resizeFile(e.target.files[0], 640, 480));
        
        let inputItemsCopy = [...inputImageItems];
        inputItemsCopy[index].file = compressedFile;
        inputItemsCopy[index].imgFile = null;

        setInputImageItems(inputItemsCopy);
    }

    const resizeFile = (file, maxWidth, maxHeight) =>
        new Promise((res) => {
            Resizer.imageFileResizer(
                file, // target file
                maxWidth, // maxWidth
                maxHeight, // maxHeight
                "JPEG", // compressFormat : Can be either JPEG, PNG or WEBP.
                90, // quality : 0 and 100. Used for the JPEG compression
                0, // rotation
                (uri) => res(uri), // responseUriFunc
                "file" // outputType : Can be either base64, blob or file.(Default type is base64)
                ,0,0	
            );
        }
    );

    const onSubmit = (data, e) => {
        try {
            if (equipmentId) {
                e.preventDefault();
                setFileLoading(true);
                const dto = {
                    id : equipmentId
                }

                let formData = new FormData();
                if(inputImageItems) {
                    let imgFiles = [];
                    for (var r=0;r<inputImageItems.length;r++) {
                        // console.log(inputImageItems[r].file)
                        if (inputImageItems[r].file && inputImageItems[r].file.name) {
                            // console.log(inputImageItems[r].file)
                            formData.append("imgFiles", inputImageItems[r].file);
                        }
                        if (inputImageItems[r].imgFile && inputImageItems[r].imgFile.id) {
                            imgFiles.push({id : inputImageItems[r].imgFile.id});
                        }
                    }
                    dto.imgFiles = imgFiles;
                }
                
                // formData.append("imgFile", imgFile);

                // if (!imgFile && (imgFileId && imgFileId !== 0)) {
                //     dto.imgFile = {id : imgFileId};
                // }
                formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
                for (var value of formData.entries()) {
                    console.log(value[0]+', ',value[1]);
                }
                openModal(modals.confirmModal, {
                    onSubmit : (value) => {
                        try {
                            const res = customFileAxios.patch(`/api/equipments/${equipmentId}:imgFile`, formData).then((res)=>{
                                setFileLoading(false);
                                setIsLoading(false);
                                setLoading(false);
                                // setImgFile(null)
                                alertMessage = t('message.common.alert.modify.done');
                                setAlertMessage(alertMessage);
                                handleAlertClick();
                                handleClose();
                            }).catch((err)=>{
                                console.log(err);
                                setFileLoading(false);
                                if (!err.response?.data?.message) {
                                    alertMessage = err.message;
                                    setAlertMessage(alertMessage);
                                    handleAlertClick();
                                } else if (err.response.data.message) {
                                    alertMessage = err.response.data.message;
                                    setAlertMessage(alertMessage);
                                    handleAlertClick();
                                }
                            });
                            // return res.data;
                        } catch (error) {
                            console.error("error :", error);
                            throw error;
                        }

                        // axios({
                        //     method: "patch",
                        //     url: process.env.REACT_APP_API_URL+"/api/equipments/"+equipmentId+":imgFile",
                        //     data: formData,
                        //     headers : {
                        //         'Content-type' : 'multipart/form-data',
                        //         accept : 'application/json,',
                        //         'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
                        //         'Accept-Language' : t('locale')
                        //     }
                        // }).then((res)=>{
                        //     setFileLoading(false);
                        //     setIsLoading(false);
                        //     setLoading(false);
                        //     setImgFile(null)
                        //     alertMessage = t('message.common.alert.modify.done');
                        //     setAlertMessage(alertMessage);
                        //     handleAlertClick();
                        //     handleClose();
                        // }).catch((err)=>{
                        //     console.log(err);
                        //     setFileLoading(false);
                        //     if (!err.response?.data?.message) {
                        //         alertMessage = err.message;
                        //         setAlertMessage(alertMessage);
                        //         handleAlertClick();
                        //     } else if (err.response.data.message) {
                        //         alertMessage = err.response.data.message;
                        //         setAlertMessage(alertMessage);
                        //         handleAlertClick();
                        //     }
                        // });
                    },
                    onClose : () => {
                        setFileLoading(false);
                        console.log('close');
                    },
                    message: t('message.common.alert.modify.question'),
                });
            }
        } catch(error) {
            console.log(error);
            setFileLoading(false);
        }
    }

    if (equipmentId && (role === ROLE.SA.code || role === ROLE.WA.code || role === ROLE.MA.code)) {
        return (
            <>
                <div style={{}}>
                    <Button variant="contained" style={{padding:"2px 5px"}} onClick={handleOpen} >{t('message.common.btn.modify')}</Button>
                </div>
                {loading &&
                <Modal className="pop_box" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <MainCard modal darkTitle content={false} style={{padding:"10px"}}>
                        <div>
                            <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/popbullet.png`} alt='' /></span>&nbsp;
                            <Chip label={t('message.common.chip.equipment.basic.picture.modify')} color="success" />
                        </div>

                        {/* <div style={{color:"red",fontWeight:"bold",textAlign:"left"}}>* {t('message.common.text.horizontal.picture.recommend')}</div> */}
                        {t('message.common.subtitle.equipment.picture.basic')}
                        {inputImageItems?.length < 4 && <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addImageFile}>+</AddCircleOutlineIcon>}
                        <CardContent style={{width:"600px",height:"100%",margin:"5px"}}>
                            <div style={{padding:"10px"}}>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    {inputImageItems && inputImageItems.map(function(item, index) {
                                    return (
                                    <div key={index} style={{display:"flex"}}>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            value={''}
                                            onChange={e => {
                                                handleImageFileChange(e, index);
                                            }}
                                        />
                                        {(item.file && item.file.name) ? item.file.name : (item.imgFile && item.imgFile.id && <><FileDownloadIcon file={item.imgFile} viewFileName={true} fontColor="#000" /></>)}
                                        { inputImageItems[index] ? (
                                            <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteImageFile(item.id)}>-</RemoveCircleOutlineIcon>
                                        ) : (
                                        ''
                                        )}
                                    </div>
                                    )
                                    })}
                                    {/* <div style={{display:"flex", justifyContent:"space-between", color:"#fff"}}>
                                        <input
                                            type="file" 
                                            accept="image/*" 
                                            onChange={(e)=>{
                                                fileChangedHandler(e, 640, 480, setImgFile);
                                                setImgFileId(null);
                                            }}
                                            style={{width:"unset"}}
                                        />
                                        {imgFileId && 
                                            <>
                                                <FileDownloadIcon file={info && info.imgFile} viewFileName={true} fontColor="#fff" />
                                                <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteImgFile()}>-</RemoveCircleOutlineIcon>
                                            </>
                                        }
                                    </div> */}
                                </form>
                            </div>
                            <div className='pop_close' style={{padding:"5px"}}>
                                <LoadingButton variant="contained" color="success" loading={fileLoading} onClick={handleSubmit(onSubmit)}>{t('message.common.btn.modify')}</LoadingButton>&nbsp;
                                <Button variant="contained" color="primary" size="small" onClick={handleClose}>
                                    {t('message.common.btn.close')}
                                </Button>
                            </div>
                        </CardContent> 
                    </MainCard>
                </Modal>
                }
            </>
        )
    }
}

export default EquipmentImgFileModifyLayer;